<template>
  <div class="pub-page" v-loading="loading">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <div>
        <text class="title me-1">{{$route.meta.title}}</text>
      </div>

<!--      <el-button type="primary"  class="ms-2 me-3" @click="handleExport">导出</el-button>-->
    </div>
    <div class="pub-center pt-2" >
      <div class="shadow-sm bg-white px-3 py-2 my-2  ">
        <el-descriptions
            class="margin-top"
            title="参赛队信息"
            :column="3"
            :label-align="'center'"
            border
        >
          <el-descriptions-item label="年份">{{infoDetail.Year}}</el-descriptions-item>
          <el-descriptions-item label="省份">{{infoDetail.Province}}</el-descriptions-item>
          <el-descriptions-item label="参赛学校">{{infoDetail.UniversityName}}</el-descriptions-item>
          <el-descriptions-item label="参赛队名">{{infoDetail.TeamName}}</el-descriptions-item>
          <el-descriptions-item label="联系人姓名">{{infoDetail.TeamContact}}</el-descriptions-item>
          <el-descriptions-item label="联系人手机号">{{infoDetail.TeamPhone}}</el-descriptions-item>
          <el-descriptions-item label="参赛组别">{{infoDetail.LevelName}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions
            class="margin-top mt-3"
            title="作品信息"
            :column="1"
            :label-width="150"
            :label-align="'center'"
            border
        >
          <el-descriptions-item label="作品名称">{{infoDetail.Name}}</el-descriptions-item>
          <el-descriptions-item  label="选题类型">{{infoDetail.TopicName}}</el-descriptions-item>
          <el-descriptions-item label="关键词">
            <el-tag class="mx-1" size="small" v-for="item of Keywords" :key="item">{{item}}</el-tag>
          </el-descriptions-item>

          <el-descriptions-item label="作品简介">{{infoDetail.Description}}</el-descriptions-item>

          <el-descriptions-item label="创新性描述" >{{infoDetail.Innovation}}</el-descriptions-item>
          <el-descriptions-item label="产业应用描述">{{infoDetail.Industry}}</el-descriptions-item>
          <el-descriptions-item label="社会经济效益">{{infoDetail.Benefits}} </el-descriptions-item>

        </el-descriptions>
        <el-descriptions
            class="margin-top mt-3"
            title="作品附件"
            :column="1"
            :label-width="150"
            :direction="'vertical' "
            border
        >
          <el-descriptions-item >
            <template #label>
              <div class="cell-item d-flex align-items-center justify-content-between">
                <text>项目可行性报告</text>
                <div>
                  <el-button type="primary" plain @click="downloadFun(infoDetail.FeasibilityUrl,infoDetail.Feasibility)">下载</el-button>
                  <el-button type="primary" plain @click="fullScreem(infoDetail.FeasibilityUrl)">全屏查看</el-button>
                </div>
              </div>
            </template>
            <div class="ifram-container" v-if="infoDetail.FeasibilityUrl">
              <pdfViewerFrame  :pdfurl="infoDetail.FeasibilityUrl"></pdfViewerFrame>
            </div>
            <div v-if="!loading && !infoDetail.FeasibilityUrl">暂未上传</div>
          </el-descriptions-item>
          <el-descriptions-item >
            <template #label>
              <div class="cell-item d-flex align-items-center justify-content-between">
                <text>项目汇报视频</text>
                <div>
<!--                  <a :href="infoDetail.VideoUrl" :download="infoDetail.Video">点击下载</a>-->
<!--                  <el-button type="primary" plain @click="downloadVedioFun(infoDetail.VideoUrl,infoDetail.Video)">下载</el-button>-->
                  <el-button type="primary" plain @click="fullScreemVedio()">全屏查看</el-button>
                </div>
              </div>
            </template>
            <div class="vedio-container" v-if="infoDetail.VideoUrl">
              <video controls  ref="videoRef">
                <source :src="infoDetail.VideoUrl" type="video/mp4">
                您的浏览器不支持视频播放
              </video>
            </div>
            <div class="text-secondary px-1 py-2" v-if="infoDetail.VideoUrl">
              提示：如果遇到只有声音，视频内容无法显示的情况（通常是因为视频编码器的兼容性问题）。您可以尝试：
             <div>1，点击 <el-button text class="text-primary point-curser px-0" @click="dialogVisibleVedio2=true">此处转码视频</el-button>播放</div>
              <div>2，点击 <el-button text :loading="vedioLoading" class="text-primary point-curser px-0"  @click="downloadVedioFun(infoDetail.VideoUrl,infoDetail.Video)" ><text v-if="!vedioLoading">此处下载视频</text> <text v-if="vedioLoading">下载中，请耐心等待...</text></el-button>，下载到本地播放。</div>
            </div>
            <div v-if="!loading && !infoDetail.VideoUrl">暂未上传</div>
          </el-descriptions-item>

          <el-descriptions-item >
            <template #label>
              <div class="cell-item d-flex align-items-center justify-content-between">
                <text>知识产权声明</text>
                <div>
                  <el-button type="primary" plain @click="downloadFun(infoDetail.IpUrl,infoDetail.Ip)">下载</el-button>
                  <el-button type="primary" plain @click="fullScreem(infoDetail.IpUrl)">全屏查看</el-button>
                </div>
              </div>
            </template>
            <div class="ifram-container" v-if="infoDetail.IpUrl">
              <pdfViewerFrame  :pdfurl="infoDetail.IpUrl"></pdfViewerFrame>
            </div>
            <div v-if="!loading && !infoDetail.IpUrl">暂未上传</div>
          </el-descriptions-item>

        </el-descriptions>

 </div>
    </div>
  </div>
  <!--  视频二播放-->
  <hlsVedioPlay :src="infoDetail.VideoUrl2" v-if="dialogVisibleVedio2"  @close="dialogVisibleVedio2=false"/>

</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import hlsVedioPlay from "@/components/hlsVedioPlay"
import {ElMessage} from "element-plus";
const loading = ref(false)
const fileUrl = '/pdfjs-4.10.38-dist/web/viewer.html?file='; // pdfjs自带文件地址
const id = ref(null)
import { useRoute  } from "vue-router";
import {getWorkDetail} from "@/api/entryAdmin";
import {getName, LEVELS} from "@/utils/commonSetting";
import pdfViewerFrame from "@/components/pdfViewerFrame"
import { useRouter } from "vue-router";
import {downLoadWithToken} from "@/utils/downloadFiles";
let router = useRouter();
const url = ref()
const route = useRoute()
const infoDetail = ref({})
const Keywords = ref([])
const videoRef = ref()
onMounted(()=>{
  if(route.query.id){
    id.value = route.query.id
  }
  getDetail()
})
const dialogVisibleVedio2 = ref(false)


// 获取详情
const getDetail = async()=>{
  if(!id.value){
   return ElMessage.warning("页面请求出错")
  }
  loading.value = true
  const res = await getWorkDetail({id:id.value})
  loading.value = false
  if(res.err_code === 0){
    const data = res.data || {}
    if(data.Keywords){
      Keywords.value = data.Keywords.split(",")
    }
    if(data.Topic){
      data.TopicName = data.Topic.Name
    }
    if(data.Team){
      data.TeamName = data.Team.Name
      data.TeamContact = data.Team.Contact
      data.TeamPhone = data.Team.Phone
      if(data.Level){
        data.LevelName = getName(LEVELS,data.Level)
      }
      if(data.Team.University){
        data.UniversityName = data.Team.University.Name
      }
    }
    infoDetail.value = data
    url.value = data.IpUrl
  }else{
    return ElMessage.error(res.err_msg || "页面请求出错")
  }


}

// 全屏查看 pdf todo 插件
const fullScreem = (url)=>{
  if(!url){
    return ElMessage.warning("未获取到文件信息")
  }
  window.open(url,"_blank") // 浏览器直接打开
  return
  // 插件打开
  const r = router.resolve({path:'/pdfjs-4.10.38-dist/web/viewer.html',query:{file:url}})
  window.open(r.href,"_blank")
}
// 全屏查看 vedio
const fullScreemVedio = ()=>{
 if(videoRef.value){
   const video = videoRef.value
   if (video.requestFullscreen) {
     video.requestFullscreen();
   } else if (video.webkitRequestFullscreen) {
     video.webkitRequestFullscreen();
   } else if (video.mozRequestFullScreen) {
     video.mozRequestFullScreen();
   } else if (video.msRequestFullscreen) {
     video.msRequestFullscreen();
   } else {
    ElMessage.warning("无法全屏")
   }
 }
}
// 下载
const downloadFun = (file,fileName)=>{
  if(!file){
    return ElMessage.warning("未找到文件")
  }
  const fn = fileName.split("/").reverse()[0]
  downLoadWithToken(file,fn)
}
// 下载視頻
const vedioLoading = ref(false)
const downloadVedioFun = (file,fileName)=>{
  if(!file){
    return ElMessage.warning("未找到文件")
  }

  const fn = fileName.split("/").reverse()[0]
  vedioLoading.value = true
  fetch(file)
      .then(response => response.blob()) // 将视频转换为 Blob
      .then(blob => {
        const url = URL.createObjectURL(blob); // 创建 Blob 对象 URL
        const a = document.createElement('a');
        a.href = url;
        a.download = fn;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url); // 释放 URL
        document.body.removeChild(a);
      }).finally(()=>{
    vedioLoading.value = false
  });

  // downLoadWithToken(file,fn)

}


</script>

<style scoped lang="scss">
.label{
  width: 180px;
  height: 40px;
  line-height: 40px;
}

.ifram-container{
  width: 100%;
  height: 1000px;
  min-width: 600px;
}
.vedio-container{
  width: 100%;
  //height: 600px;
  //max-width: 750px;
  min-width: 600px;
  display: flex;
  align-items: center;
  justify-content: center;

}
video {
  width: 100%; /* 适配父容器宽度 */
  max-width: 650px;
  //max-height: 100%;
  height: auto; /* 根据宽度自动调整高度，保持比例 */
  //width: auto; /* 适配父容器宽度 */
  //max-width: 100%;
  //height: 100%; /* 根据宽度自动调整高度，保持比例 */
  border: 1px solid #ccc; /* 添加边框 */
  border-radius: 8px; /* 圆角效果 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 添加阴影 */
}
</style>
